import React from 'react';
import { createSelectBoxClassName } from './selectBoxStyles';

export const SelectBoxWrapper: React.FC = ({ children }) => (
  <div className={createSelectBoxClassName('wrapper')}>{children}</div>
);
